import { type PropsWithChildren, type ReactNode } from 'react';

import styles from './ContentLayout.css';

export function ContentLayout({ children }: PropsWithChildren): ReactNode {
  return <article className={styles['container']}>{children}</article>;
}

type BlockProps = {
  as?: 'div' | 'section';
  size: 's' | 'm' | 'l';
};

function Block({ children, as: BlockTagComponent = 'div', size }: PropsWithChildren<BlockProps>): ReactNode {
  return <BlockTagComponent className={styles[`block-${size}`]}>{children}</BlockTagComponent>;
}
/**
 * Грид контейнер с gap = 4px
 */
function BlockS(props: PropsWithChildren<Omit<BlockProps, 'size'>>): ReactNode {
  return <Block size="s" {...props} />;
}
/**
 * Грид контейнер с gap = 8px
 */
function BlockM(props: PropsWithChildren<Omit<BlockProps, 'size'>>): ReactNode {
  return <Block size="m" {...props} />;
}
/**
 * Грид контейнер с gap = 16px
 */
function BlockL(props: PropsWithChildren<Omit<BlockProps, 'size'>>): ReactNode {
  return <Block size="l" {...props} />;
}

function Footer({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['footer']}>{children}</div>;
}

ContentLayout.BlockS = BlockS;
ContentLayout.BlockM = BlockM;
ContentLayout.BlockL = BlockL;
ContentLayout.Footer = Footer;
